import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import UserForm from "components/users/UserForm";
import { createRoleUser, deleteRoleUser, updateUser } from "graphql/mutations";
import { customGetUser } from "graphql/custom-queries";
import { roleUsersByRoleId } from "graphql/queries";

const UserUpdateForm = ({ userId, onSuccess }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState();

  async function onSubmit(values) {
    try {
      const {
        name,
        birthDate,
        position,
        sex,
        gender,
        phones,
        additionalEmails,
        addresses,
        companyID,
        isSuper,
        isTechnician,
        roles,
      } = values;
      const promises = [];

      const rolesToUnLink = user.roles
        ?.filter((userUs) => !roles?.some((role) => role.id === userUs.id))
        ?.map((role) => role.id);
      rolesToUnLink?.forEach(async (roleId) => {
        const userRoleRecords = (
          await API.graphql({
            query: roleUsersByRoleId.replaceAll("__typename", ""),
            variables: {
              roleId,
              filter: {
                and: [{ userId: { eq: userId } }],
              },
            },
          })
        )?.data?.roleUsersByRoleId?.items;
        promises.push(
          API.graphql({
            query: deleteRoleUser.replaceAll("__typename", ""),
            variables: {
              input: {
                id: userRoleRecords[0].id,
              },
            },
          })
        );
      });
      const rolesToLink = roles
        ?.filter(
          (role) => !user.roles?.some((userRole) => userRole.id === role.id)
        )
        ?.map((role) => role.id);
      rolesToLink?.forEach((roleId) => {
        promises.push(
          API.graphql({
            query: createRoleUser.replaceAll("__typename", ""),
            variables: {
              input: {
                userId,
                roleId,
              },
            },
          })
        );
      });

      promises.push(
        API.graphql({
          query: updateUser.replaceAll("__typename", ""),
          variables: {
            input: {
              id: userId,
              name,
              birthDate,
              position,
              sex,
              gender,
              phones,
              additionalEmails,
              addresses,
              companyID,
              isSuper,
              isTechnician,
            },
          },
        })
      );

      await Promise.all(promises);

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/users");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchUser(id) {
    try {
      const userData = await API.graphql(
        graphqlOperation(customGetUser, { id })
      );
      const userItem = userData.data.getUser;
      if (!userItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/users");
        return;
      }
      setUser({
        ...userItem,
        permissions: [
          ...new Set(
            [].concat(
              ...userItem.roles.items?.map((r) =>
                r.role.permissions.items?.map((perm) => perm.permission.name)
              )
            )
          ),
        ],
        roles: userItem.roles.items?.map((r) => ({
          id: r.role.id,
          name: r.role.name,
        })),
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchUser(userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (!user) return <Loader />;

  return (
    <div>
      <UserForm onSubmit={onSubmit} type="update" initialValues={user} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Usuario",
    successUpdated: "Usuario actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el usuario",
    },
  },
});

export default UserUpdateForm;
